module.exports = __webpack_public_path__ + "img/Domain_Eng.80ae2a56.png";